/* eslint-disable @typescript-eslint/no-var-requires */
import setDocumentTitle from 'I18n/utils/setDocumentTitle';
import { AppRoot, renderAppRoot } from 'quartz-core/internal/root-renderer';
import { initializeI18n } from '../frameworkInternal/tools/i18n/i18n';
import config from './quartz-config-for-app';
import { initializeHistory } from '../frameworkInternal/tools/history/history';
import { mark } from './perf';
import registerAllPublicData from 'I18n/init/register/sync/registerAllPublicData';
import { isPromiseLike } from './isPromiseLike';
import { jsx as _jsx } from "react/jsx-runtime";
export const renderApp = async ({
  prepareApp,
  AppComponent,
  getLocaleInfo
}, {
  rhumbConfig,
  lang
}) => {
  if (config.auth !== 'none') {
    throw new Error(`Invariant: expected auth="none"`);
  }
  const {
    htmlTitleLangKey,
    historyBasename
  } = config;
  const history = initializeHistory(historyBasename);
  const localeInfoResult = getLocaleInfo === null || getLocaleInfo === void 0 ? void 0 : getLocaleInfo();
  const localeInfo = isPromiseLike(localeInfoResult) ? await localeInfoResult : localeInfoResult;
  const [result] = await Promise.all([prepareApp(), initializeI18n({
    lang,
    createPublicProvider: true,
    registerFn: registerAllPublicData,
    localeInfo
  })]);
  mark('quartz.prepareAppFinished');
  if (htmlTitleLangKey) {
    setDocumentTitle(htmlTitleLangKey);
  }
  if (result && 'redirect' in result) {
    window.location.href = result.redirect;
  } else {
    var _result$onAfterRender;
    await renderAppRoot( /*#__PURE__*/_jsx(AppRoot, {
      history: history,
      rhumbConfig: rhumbConfig,
      rhumbTrackVisibility: config.rhumbTrackVisibility,
      children: /*#__PURE__*/_jsx(AppComponent, Object.assign({}, result === null || result === void 0 ? void 0 : result.props))
    }), {
      legacyRoot: !config.createRootApi,
      strictMode: config.reactStrictMode
    });
    result === null || result === void 0 || (_result$onAfterRender = result.onAfterRender) === null || _result$onAfterRender === void 0 || _result$onAfterRender.call(result);

    // @ts-expect-error need to rethink $quartzConfigVal
    if (undefined) {
      const {
        getAppExtensions
      } = require('./plugins/app-plugins');
      for (const plugin of getAppExtensions()) {
        plugin.hooks.onAfterRender();
      }
    }
  }
};